import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

let updateObjednavkyTimeout = false;
let updateObjednavkyRequest = false;

function check_hidden_inputs(elm) {
    const $registeredInputs = $(elm).closest('form').find('input[name="registered"]');

    if (!$(elm).is(":checked")) {
        $("#" + $(elm).attr("data-box")).addClass("hide");
        $registeredInputs.val(0);
    }
    else {
        $("#" + $(elm).attr("data-box")).removeClass("hide");
        $registeredInputs.val(1);
    }
}

window.updateObjednavky = () => {
    const $form = $(".js-form-cart-modules");

    if (updateObjednavkyTimeout) {
        clearTimeout(updateObjednavkyTimeout);
    }

    if (updateObjednavkyRequest) {
        updateObjednavkyRequest.abort();
    }

    updateObjednavkyTimeout = setTimeout(() => {
        updateObjednavkyRequest = $.post($form.data('update-action'), $form.serialize(), function (data) {
            let recapTotals = Eshop.options.pricesWithVat ? data.totals.total : data.totals.subtotal

            Cart.updates.totals(data.totals)

            for (const type of ['payment', 'shipping']) {
                const isSelected = $(`input[name="${type}_id"]:checked`).length > 0
                const value = data.totals[type]
                const $holder = $(`.js-cart-recap-${type}-holder`)
                const $text = $(`.js-cart-recap-${type}-text`)
                const $valueEl = $(`.js-cart-recap-${type}`)

                $holder.toggleClass('hidden', !isSelected)

                if (isSelected) {
                    const name = $(`input[name="${type}_id"]:checked`).data('name').toString().trim()
                    $text.text(`(${name})`)
                }

                if (value) {
                    $valueEl.removeClass('is-green').html(Format.price(value))
                } else {
                    $valueEl.html($valueEl.data('free'))
                    $valueEl.addClass('is-green')
                }

                recapTotals -= value
            }

            recapTotals -= data.totals.discount

            $('.js-recap-totals').html(Format.price(recapTotals))
        }, "json");

        updateObjednavkyTimeout = false;
    }, 200);
}

$(function () {
    $('.branch-info__box[data-id="' + $('#branch_id').val() + '"]').addClass('is-active');

    // old stuff from modules.ctp
    $('input[name="shipping_id"]').on('change', function () {
        const $form = $(".js-form-cart-modules");
        const isZasielkovna = $(this).data('zasielkovna');

        $('input[name="shipping_method"]').val($(this).data('name'));

        $('input[name="shipping_id"]').each(function() {
            const isChecked = $(this).is(':checked');

            for (const inputName of ['branch_id', 'shipping_module_id', 'shipping_name', 'shipping_address', 'shipping_post_code', 'shipping_city', 'shipping_phone']) {
                $(this)
                    .closest('.js-shipping-modules-item')
                    .find('input[name="' + inputName + '"]')
                    .attr('disabled', !isChecked);
            }
        });

        var payments = $(this).data('payments');
        $('input[name="payment_id"]').not('[data-disabled="true"]').prop('disabled', false);
        $('input[name="payment_id"]').filter(function (index) {
            return _.indexOf(payments, parseInt($(this).val())) == -1;
        }).prop('disabled', true).prop('checked', false).trigger('change');

        if ($(this).val() != $('[name="branch_id"]').parents('.shopping-modules__item').find('[name="shipping_id"]').val()) {
            $('[name="branch_id"]:checked').prop('checked', false).trigger('change');
        }

        if ($(this).is(':checked')) {
            if ($('#error-shipping').is(':visible')) {
                $('#error-shipping').hide();
            }
            if ($('#error-branch').is(':visible')) {
                $('#error-branch').hide();
            }
        }
    });

    $('input[name="payment_id"]').not('[data-disabled="true"]').on('change', function () {
        if ($(this).is(':checked')) {
            $('input[name="payment_method"]').val($(this).data('name'));

            var isInsideFakeInput = $(this).closest('.js-fake-payment-input').length;

            if (!isInsideFakeInput) {
                $('.js-fake-payment-input').removeClass('is-checked')
            }

            if ($('#error-payment').is(':visible')) {
                $('#error-payment').hide();
            }
        }
    });

    $('input[name="branch_id"]').on('change', function () {
        if ($(this).is(':checked') && $('#error-branch').is(':visible')) {
            $('#error-branch').hide();
        }
    });

    $('input[name="shipping_id"]:checked').trigger('change');

    // modules validate
    $('.js-form-cart-modules').on('submit', function (event) {
        event.preventDefault();
    }).validate({
        errorPlacement: function (error, element) {
            if (element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {
            let result = true;

            if (!$('[name="payment_id"]').not('[data-disabled="true"]').is(':checked')) {
                $('#error-payment').fadeIn(500);
                result = false;
            } else {
                if ($('#error-payment').is(':visible')) { $('#error-payment').fadeOut(500); }
            }

            if (!$('[name="shipping_id"]').is(':checked')) {
                $('#error-shipping').fadeIn(500);
                result = false;
            } else {
                if ($('#error-shipping').is(':visible')) { $('#error-shipping').fadeOut(500); }

                // branch pickup || parcelshop
                if (
                    !$('[name="branch_id"]').is(':checked') && $('[name="branch_id"]').parents('.shopping-modules__item').find('[name="shipping_id"]').is(':checked') ||
                    !$('[r-sps-parcelshop-input]').val() && $('[r-sps-parcelshop-input]').parents('.shopping-modules__item').find('[name="shipping_id"]').is(':checked') ||
                    !$('[r-zasielkovna-input]').val() && $('[r-zasielkovna-input]').parents('.shopping-modules__item').find('[name="shipping_id"]').is(':checked')
                ) {
                    $('#error-branch').fadeIn(500);

                    result = false;
                }
                else {
                    if ($('#error-branch').is(':visible')) { $('#error-branch').fadeOut(500); }
                }
            }

            if (result) {
                $('.js-form-cart-modules-submit')
                    .prop('disabled', true)
                    .addClass('is-loading');

                if (updateObjednavkyRequest) {
                    updateObjednavkyRequest.abort();
                }

                if (!$('[name="branch_id"]').parents('.shopping-modules__item').find('[name="shipping_id"]').is(':checked')) {
                    $('[name="branch_id"]').val('')
                }
                if (!$('[r-sps-parcelshop-input]').parents('.shopping-modules__item').find('[name="shipping_id"]').is(':checked')) {
                    $('[r-sps-parcelshop-input]').val('')
                }
                if (!$('[r-zasielkovna-input]').parents('.shopping-modules__item').find('[name="shipping_id"]').is(':checked')) {
                    $('[r-zasielkovna-input]').val('')
                    $('[r-zasielkovna-additional-input]').val('')
                }

                const customPromisedDate = $('input[name="shipping_id"]:checked').data('custom-promised-date');
                $('input[name="custom_promised_date"]').val(customPromisedDate);

                form.submit();
            }
            else {
                window.scroll({
                    top: $('.c-msg--error:visible').first().offset().top - 64,
                    behavior: 'smooth'
                })
            }
        }
    });

    $('.js-form-cart-modules').find('input[type="radio"]').on('change', function () {
        window.updateObjednavky();
    });

    $('.js-form-cart-modules-submit').on('click', function () {
        $('.js-form-cart-modules').submit();
    });

    // reg form
    if ($('.js-form-reg').length > 0) {
        check_hidden_inputs($("#order-registered, #customer-registered"));

        $("#order-registered, #customer-registered").change(function () {
            check_hidden_inputs($(this));
        });
    }

    $('.js-vouchers-form').on('submit', e => e.preventDefault()).validate({
        submitHandler: function (form) {
            var $form = $(form);

            $form.find('input[name="voucher"]').blur();
            $form.find('button[type="submit"]').addClass('is-loading');

            Form.ajaxPost(form, function (data) {
                Eshop.tippyAlert($form.find('button[type="submit"]')[0], data.message, {
                    theme: data.status ? 'success' : 'error'
                }, 10000);

                if (data.status) {
                    location.reload();
                } else {
                    $form.find('button[type="submit"]').removeClass('is-loading');
                }
            }, "json");
        }
    });

    $('.js-recap-products-overflow').one('scroll', function() {
        $(this).removeClass('has-overflow has-overflow-sm');
    });

    $('.js-fake-payment-input-trigger').on('click', function(e) {
        const $fakePaymentInputHolder = $(this).closest('.js-fake-payment-input');

        e.preventDefault();

        if (!$fakePaymentInputHolder.hasClass('is-checked')) {
            $('[name="payment_id"]:checked').prop('checked', false).trigger('change');
        }

        $fakePaymentInputHolder.addClass('is-checked');
    })

    $('.js-import-form-input').on('change', function () {
        $('.js-import-form').submit();

        $(this).prop('disabled', true);
        $(this).siblings('.c-btn').addClass('is-loading');
    });

    $('.js-shopping-model').validate({
        submitHandler: function (form) {
            $(form).find('button[type="submit"]').addClass('is-loading');
            form.submit()
        }
    });

    $('.js-shopping-model').on('keypress', function(event) {
        const isEnter = event.key == 'Enter';

        if (isEnter && $(event.target).hasClass('js-model-number')) {
            event.preventDefault();

            $('.js-model-quantity').focus();
        }
    });

    if (window.location.search.indexOf('model') == 1 && document.getElementsByClassName('js-model-number').length) {
        if (!$('.shopping-quick__header').hasClass('is-active')){
            $('.shopping-quick__header').click();
        }

        setTimeout(function() {
            $('.js-model-number').focus();
        }, 250);
    }

    if ($('input[name="payment_id"][data-disabled="true"]:checked').length) {
        $('input[name="payment_id"][data-disabled="true"]:checked').prop('checked', false).trigger('change');
    }
});
